<template>
  <modal
    :show.sync="isActiveLocal"
    size="xl"
    centered
    modal-content-classes="cust-modal-ht-wo"
    hide-header
    class="overflow-y-hidden"
  >
    <div class="text-black md:p-8 lg:p-8 p-0">
      <div class="">
        <div class="flex justify-between pb-4">
          <div class="flex">
            <img
              :src="`${$imageURL}/${selectedTesimonial.image}`"
              alt="user"
              class="md:h-32 lg:h-32 h-16 md:w-32 lg:w-32 w-16 md:mx-4 lg:mx-4 rounded-full"
            />
            <div class="mx-2 my-auto">
              <h2 class="uppercase clr-black fsize16 font-semibold pt-4">
                {{ selectedTesimonial.title }}
              </h2>

              <p class="pt-2 clr777 font-normal">
                {{
                  new Date(selectedTesimonial.date).toLocaleDateString(
                    "en-IN",
                    {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    }
                  )
                }}
              </p>
            </div>
          </div>
          <img
            src="../../../assets/images/cross.png"
            class="md:h-8 lg:h-8 h-6 md:w-8 lg:w-8 w-6 cursor-pointer"
            alt="cross"
            @click="isActiveLocal = false"
          />
        </div>
        <div class="pt-4">
          <p
            class="description-container"
            v-html="selectedTesimonial.description"
          ></p>
        </div>
      </div>
    </div>
    <template slot="footer">
      <p></p>
    </template>
  </modal>
</template>
<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedTesimonial: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.description-container {
  max-height: 300px;
  overflow-y: auto;
  padding-right: 8px;
}

/* Custom Scrollbar Styles */
.description-container::-webkit-scrollbar {
  width: 8px;
}

.description-container::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.description-container::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}

.description-container::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  border-radius: 4px;
}
</style>
